/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RateConfigRuleSetRulesInner
 */
export interface RateConfigRuleSetRulesInner {
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRuleSetRulesInner
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'binSponsor'?: RateConfigRuleSetRulesInnerBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'creditOrPrepaid'?: RateConfigRuleSetRulesInnerCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRuleSetRulesInner
     */
    'minimumTotalAmount': number;
}

export const RateConfigRuleSetRulesInnerBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateConfigRuleSetRulesInnerBinSponsorEnum = typeof RateConfigRuleSetRulesInnerBinSponsorEnum[keyof typeof RateConfigRuleSetRulesInnerBinSponsorEnum];
export const RateConfigRuleSetRulesInnerCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateConfigRuleSetRulesInnerCreditOrPrepaidEnum = typeof RateConfigRuleSetRulesInnerCreditOrPrepaidEnum[keyof typeof RateConfigRuleSetRulesInnerCreditOrPrepaidEnum];


